// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Uqh-L","type":"styles_type__kshAh","choices":"styles_choices__1bvH-"};